import { CSSProperties } from 'react'

import { capitalizeFirstLetter } from 'primsell-shared-layer/helpers'
import { PurchaseE } from 'primsell-shared-layer/types'

import * as S from './purchase-type-indicator.styles'

export interface IPurchaseTypeIndicatorProps {
  type: PurchaseE | null
}

const BADGE_BORDER_COLOR: Record<PurchaseE, CSSProperties['borderColor']> = {
  [PurchaseE.PRIMARY]: '#8968F5',
  [PurchaseE.SECONDARY]: '#2C72DB',
}
const BADGE_BACKGROUND_COLOR: Record<PurchaseE, CSSProperties['backgroundColor']> = {
  [PurchaseE.PRIMARY]: '#8968F54D',
  [PurchaseE.SECONDARY]: '#2C72DB33',
}

const BADGE_TEXT_COLOR: Record<PurchaseE, CSSProperties['color']> = {
  [PurchaseE.PRIMARY]: '#7859DB',
  [PurchaseE.SECONDARY]: '#2C72DB',
}

export const PurchaseTypeIndicator = ({ type }: IPurchaseTypeIndicatorProps) => {
  if (!type) {
    return null
  }
  return (
    <S.PurchaseContainer backgroundColor={BADGE_BACKGROUND_COLOR[type]} borderColor={BADGE_BORDER_COLOR[type]}>
      <S.TypeText textcolor={BADGE_TEXT_COLOR[type]}>{capitalizeFirstLetter(type)}</S.TypeText>
    </S.PurchaseContainer>
  )
}
